import { useWizardWithQueryParamAndOperations } from "@coworker/apprestructured/src/shared/hooks/wizard/useWizardOperations/useWizardWithQueryParamAndOperations";
import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { useTranslation } from "@coworker/locales";

export enum WizardStep {
  WorkBrief = "WorkBrief",
  ProductSelection = "ProductSelection",
  DirectTakeaway = "DirectTakeaway",
}

type UseWizardArgs = {
  steps: readonly WizardStep[];
  onComplete: () => Promise<void>;
};

export const useWizard = ({ steps, onComplete }: UseWizardArgs) => {
  const { t } = useTranslation();
  const { showToast } = useToastNotification();

  return useWizardWithQueryParamAndOperations<WizardStep, never>({
    steps,
    onError: () => showToast(t("errorBoundaryString")),
    executeOperation: () => Promise.resolve(),
    onComplete,
  });
};
